import { IState } from 'shared/store';

export const isAutorisationPopupOpenSelector = (state: IState) => state.consultantCianChat.isAutorisationPopupOpened;
